module.exports = __webpack_public_path__ + "static/img/reporticon8.6573898b.png";